import React from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";

const LoadingSpinner = ({ text = "Loading..." }) => (
  <Wrapper>
    <CircularProgress />
    {text}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  place-content: center;
  flex-direction: column;
`;

export default LoadingSpinner;
